import {RouteConfig} from 'vue-router';
import {
	META_ALLOW_ANONYMOUS_ACCESS,
	ERouteName,
	RequireActiveLocationId,
} from '@customer-portal/shared';

const routes: RouteConfig[] = [
	{
		path: '/login',
		component: () => {
			return import('layouts/LoggedOutLayout.vue');
		},
		children: [
			{
				name: ERouteName.Login,
				path: '',
				component: () => {
					return import('pages/Login.vue');
				}
			}
		],
		meta: {
			...META_ALLOW_ANONYMOUS_ACCESS,
		},
	},
	{
		path: '/accept-tos',
		component: () => {
			return import('layouts/OverlayPage.vue');
		},
		children: [
			{
				name: ERouteName.AcceptTOS,
				path: '',
				component: () => {
					return import('pages/AcceptTOS.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/app-install-reward',
		component: () => {
			return import('layouts/OverlayPage.vue');
		},
		children: [
			{
				name: 'App Install Reward',
				path: '',
				component: () => {
					return import('pages/AppInstallReward.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/opportunity/:id',
		component: () => {
			return import('layouts/OverlayPage.vue');
		},
		children: [
			{
				name: 'Unclaimed Reward',
				path: '',
				component: () => {
					return import('pages/UnclaimedReward.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/nps/:id',
		component: () => {
			return import('layouts/OverlayPage.vue');
		},
		children: [
			{
				name: 'Unclaimed NPS',
				path: '',
				component: () => {
					return import('pages/UnclaimedNPSPage.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '',
		name: ERouteName.Launch,
		props: {
			bounceToHome: 'true' // string booleans are gross but the only thing supported
		},
		component: () => {
			return import('pages/Launch.vue');
		},
		meta: {
			...META_ALLOW_ANONYMOUS_ACCESS,
		},
	},
	{
		path: '/home',
		component: () => {
			return import('layouts/FullPage.vue');
		},
		children: [
			{
				name: ERouteName.Home,
				path: '',
				component: () => {
					return import('pages/Home.vue');
				},
				props: {
					handleScreenPops: 'false'
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/landing/:campaignId',
		name: ERouteName.Landing,
		component: () => import('@/pages/Landing.vue'),
		props: true,
		meta: {
			...META_ALLOW_ANONYMOUS_ACCESS,
		},
	},
	{
		path: '/specials',
		component: () => {
			return import('layouts/OverlayPage.vue');
		},
		children: [
			{
				name: 'Specials',
				path: '',
				component: () => {
					return import('pages/Specials.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/loyalty-info',
		component: () => {
			return import('layouts/OverlayPage.vue');
		},
		children: [
			{
				name: 'Loyalty Info',
				path: '',
				component: () => {
					return import('pages/LoyaltyInfo.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{

		path: '/map',
		component: () => {
			return import('layouts/FullPage.vue');
		},
		children: [
			{
				name: ERouteName.Map,
				path: '',
				component: () => {
					return import('pages/Map.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{

		path: '/locations',
		component: () => {
			return import('layouts/OverlayPage.vue');
		},
		children: [
			{
				name: ERouteName.Locations,
				path: '',
				component: () => {
					return import('pages/Locations.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{

		path: '/menu',
		component: () => {
			return import('layouts/FullPage.vue');
		},
		children: [
			{
				name: ERouteName.Menu,
				path: '',
				component: () => {
					return import('pages/Menu.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	// {
	// 	path: '/public-menu',
	// 	component: () => {
	// 		return import('layouts/OverlayPage.vue');
	// 	},
	// 	children: [
	// 		{
	// 			name: 'Public Menu',
	// 			path: '',
	// 			component: () => {
	// 				return import('pages/Menu.vue');
	// 			},
	// 			meta: {
	// 				requiresAuth: false
	// 			}
	// 		}
	// 	]
	// },
	{

		path: '/visit',
		component: () => {
			return import('layouts/FullPage.vue');
		},
		children: [
			{
				name: ERouteName.VisitDetail,
				path: '',
				component: () => {
					return import('pages/Visit.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/rewards',
		component: () => {
			return import('layouts/FullPage.vue');
		},
		children: [
			{
				name: ERouteName.Reward,
				path: '',
				component: () => {
					return import('pages/Rewards.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{

		path: '/profile',
		component: () => {
			return import('layouts/OverlayPage.vue');
		},
		children: [
			{
				name: ERouteName.Profile,
				path: '',
				component: () => {
					return import('pages/Profile.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/qr-code',
		component: () => {
			return import('layouts/OverlayPage.vue');
		},
		children: [
			{
				name: ERouteName.QRCode,
				path: '',
				component: () => {
					return import('pages/QRCode.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/mobile-reload',
		component: () => {
			return import('layouts/MobileWebView.vue');
		},
		children: [
			{
				name: 'Mobile Reload',
				path: '',
				component: () => {
					return import('pages/ReloadGiftCard.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/mobile',
		component: () => {
			return import('layouts/MobileWebView.vue');
		},
		children: [
			{
				name: 'Tokenize',
				path: 'tokenize',
				component: () => {
					return import('pages/TokenizeMobilePay.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/delete-account',
		component: () => {
			return import('layouts/OverlayPage.vue');
		},
		children: [
			{
				name: ERouteName.AccountDelete,
				path: '',
				component: () => {
					return import('pages/DeleteAccount.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		path: '/order',
		component: () => {
			return import('layouts/OrderOverlay.vue');
		},
		children: [
			{
				name: ERouteName.Order,
				path: '',
				component: () => {
					return import('pages/order/OrderPage.vue');
				},
				meta: {
					requiresAuth: true
				},
				beforeEnter: RequireActiveLocationId,
				children: [
					{
						name: ERouteName.MenuCategory,
						path: 'menu-category/:menuCategoryId',
						props: true,
						component: () => {
							return import('pages/order/menu-category/MenuCategory.vue');
						},
						meta: {
							requiresAuth: true
						},
						beforeEnter: RequireActiveLocationId,
					}
				]
			},
		]
	},
	{
		path: '/order-tracker',
		component: () => {
			return import('layouts/OverlayPage.vue');
		},
		children: [
			{
				name: ERouteName.OrderTracker,
				path: '',
				component: () => {
					return import('pages/order/OrderTracker.vue');
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	},
	{
		name: ERouteName.ThankYou,
		path: '/thank-you',
		component: () => {
			return import('pages/order/ThankYou.vue');
		},
		props: true,
		meta: {
			requiresAuth: true
		},
	},
	{
		path: '/share/:hash',
		name: ERouteName.Share,
		component: () => import('@/pages/Share404.vue'),
		meta: {
			...META_ALLOW_ANONYMOUS_ACCESS,
		},
	},
	// {
	// 	path: '/push-notification-request',
	// 	component: () => {
	// 		return import('layouts/OverlayPage.vue');
	// 	},
	// 	children: [
	// 		{
	// 			name: 'Push Notification Request',
	// 			path: '',
	// 			component: () => {
	// 				return import('pages/PushNotificationRequest.vue');
	// 			}
	// 		}
	// 	]
	// },
	// {
	// 	path: '/push-notification-disabled',
	// 	component: () => {
	// 		return import('layouts/OverlayPage.vue');
	// 	},
	// 	children: [
	// 		{
	// 			name: 'Push Notification Disabled',
	// 			path: '',
	// 			component: () => {
	// 				return import('pages/PushNotificationsDisabled.vue');
	// 			}
	// 		}
	// 	]
	// },
	// {
	// 	path: '/test',
	// 	component: () => {
	// 		return import('layouts/OverlayPage.vue');
	// 	},
	// 	children: [
	// 		{
	// 			name: 'Test',
	// 			path: '',
	// 			component: () => {
	// 				return import('pages/Test.vue');
	// 			}
	// 		}
	// 	]
	// },
	// {
	//
	// 	path: '/pay',
	// 	component: () => {
	// 		return import('layouts/OverlayPage.vue');
	// 	},
	// 	children: [
	// 		{
	// 			name: 'Pay',
	// 			path: '',
	// 			component: () => {
	// 				return import('pages/Pay.vue');
	// 			}
	// 		}
	// 	]
	// },

	// Always leave this as last one,
	// but you can also remove it
	{
		path: '*',
		component: () => {
			return import('pages/Error404.vue');
		}
	}
];

export default routes;
